module.exports = __webpack_public_path__ + "assets/img/settle_header_b.0d2ace75.png";